// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__RPlNd"};